import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useApiClient } from '../../../../context/ApiClientContext';
import TemplateListSelector from '../../../Template/TemplateList/TemplateListSelector';

function OfferTemplatesForm(props) {
  const { actionListId, onSuccess } = props;

  const apiClient = useApiClient();

  const handleAdd = (
    (listId) => apiClient.addOfferTemplatesAction(actionListId, listId)
  );

  return (
    <Grid container>
      <Grid item xs={6}>
        <TemplateListSelector
          handleSubmit={handleAdd}
          buttonText="Add"
          successMsg="Added"
          onSuccess={onSuccess}
        />
      </Grid>
    </Grid>
  );
}

OfferTemplatesForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default OfferTemplatesForm;
